// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "stylesheets/" + chunkId + "." + {"166":"a50daa01f4","585":"4a1e740ed3"}[chunkId] + ".min.css";
};